import type { MegaGridColumn, MegaGridView, MegaGridViewState } from '@/design/MegaGrid/MegaGridTypes';
import type { AdoptionBreakdownRow } from './AdoptionTypes';

/** A flat (ungrouped) default view state over the given columns — the base each preset overrides. */
function baseState(columns: MegaGridColumn<AdoptionBreakdownRow>[]): MegaGridViewState {
    return {
        search: '',
        sorts: [],
        filters: [],
        facets: {},
        columnOrder: columns.map((column) => column.key),
        hidden: columns.filter((column) => column.defaultHidden).map((column) => column.key),
        widths: {},
        pinned: [],
        groupBy: [],
        density: 'comfortable',
    };
}

/**
 * The two pinned segment presets for the adoption drivers grid. Power users are
 * the Leading band (adoption ≥ 75); Idle users are the Dormant/Inactive tail
 * (adoption < 25 — inactive rows score 0, so they're included). Both are flat,
 * adoption-sorted people lists. Seeded by stable id, so a user's own edits or
 * deletions stick and are never re-seeded over.
 */
export function adoptionSavedViews(columns: MegaGridColumn<AdoptionBreakdownRow>[]): MegaGridView[] {
    const base = baseState(columns);
    return [
        {
            id: 'adoption-power-users',
            name: 'Power users',
            pinned: true,
            state: {
                ...base,
                filters: [{ id: 'seed-power', columnKey: 'adoption', op: 'gte', value: 75 }],
                sorts: [{ key: 'adoption', dir: 'desc' }],
            },
        },
        {
            id: 'adoption-idle-users',
            name: 'Idle users',
            pinned: true,
            state: {
                ...base,
                filters: [{ id: 'seed-idle', columnKey: 'adoption', op: 'lt', value: 25 }],
                sorts: [{ key: 'adoption', dir: 'asc' }],
            },
        },
    ];
}
